<template>
	<div class="steps d-flex flex-column flex-sm-row align-items-center justify-content-between">
        <div class="px-2 col align-items-center d-flex justify-content-center"
            :class="{ active: index < activeStep, current: index == activeStep-1 }"
            v-for="(step,index) in steps">
            <a :href="step[2]"><h3><i :class="iconClass(step)"></i> {{ step[0] }}</h3></a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            steps: [
                [ '1. Cart', 'shopping-cart', '/cart'],
                [ '2. Address', 'address-card', '/order/address'],
//                [ '3. Delivery type', 'truck', '/order/delivery'],
                [ '3. Summary', 'clipboard', '/order/summary'],
                [ '3. Finish', 'clipboard', '/order/finish'],
            ]
        }
    },
    props: {
        activeStep: {
            default: 1,
            type: Number
        }
    },
    methods: {
        iconClass: function(step){
            return [ 'fa', 'fa-'+step[1] ];
        }
    },
    mounted() {
    },
    components: {
    }
}
</script>
<style scoped lang="scss">
@import '~@/_variables.scss';
.steps{
    border-radius: 0.5rem;
    overflow: hidden;
}
.col{
    height: 5rem;
    background: $darkgrey;
    color: $lightgrey;
    position: relative;
    &.active{
        color: $white;
        &.current{
            background: $red;
            &:after{
                border-left-color: $red;
            }
        }
        &:after{
            border-left-color: $lightgrey;
        }
        background: $lightgrey;
    }
    h3{
        margin: 0;
    }
    a{
        color: inherit;
        text-decoration: none;
    }
    &:after{
        left: 100%;
        top: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: transparent;
        border-left-color: $darkgrey;
        border-width: 1.5rem;
        margin-top: -1.5rem;
        z-index: 2;
    }
    &:last-child{
        &:after{
            content: '';
            border: 0;
        }
    }
}
</style>
